<template>
  <div class="top-img" :style="{height: height === 'auto' ? 'auto' : (height / 100).toFixed(2) + 'rem'}">
    <img :src="imgUrl" alt="">
  </div>
</template>

<script>
  export default {
    name: 'TopImg',
    props: {
      imgUrl: {
        type: String,
      },
      height: {
        type: String
      }
    }
  }
</script>

<style scoped lang="less">
  .top-img {
    width: 7.5rem;
    height: 8.44rem;
    overflow: hidden;
    img {
      width: inherit;
    }
  }
</style>
